import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {AggregatedDeadline} from '@components/aggregated/aggregated-deadline'
import {AggregatedUsers} from '@components/aggregated/aggregated-users'
import {useBoardStore} from '@components/board/board-store'
import {useColumnStore} from '@components/columns/column-store'
import {AggregatedStickerValues} from '@components/columns/column-title/aggregated-sticker-values'
import {
  TwTaskGroupTitle,
  TwTaskGroupTitleText,
  TwTitleRow
} from '@components/columns/column-title/containers'
import {MultiActionsCheckbox} from '@components/columns/column-title/multi-actions-checkbox'
import {Badge} from '@components/common/base/badge'
import {IconButtonNew} from '@components/common/base/buttons'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {downloadDashboardXlsx} from '@components/statistics/stats-reports/stats-reports-get-tasks'

export const ReportColumnHeader = observer(() => {
  const [state, store] = useColumnStore()
  const [, boardStore] = useBoardStore()
  const column = store.column

  const downloadReport = useCallback(
    () => column.data.report && downloadDashboardXlsx(column.data.report, true),
    [column.data.report]
  )
  const startEdit = useCallback(
    () => boardStore.startEditReport(column),
    [column]
  )

  return (
    <TwTaskGroupTitle
      onDrop={store.onDrop}
      onDragOver={store.onDragOver}
      onDragLeave={store.onDragLeave}
      className="px-8 pb-8"
    >
      <TwTitleRow className="text-secondary uppercase font-semibold text-10">
        {Lang.msg.reportColumn}
      </TwTitleRow>
      <TwTitleRow className="min-h-24">
        <MultiActionsCheckbox columnId={column.id} />
        <Icon
          icon="IconFileDescription"
          className="!h-24"
          hint={Lang.msg.dashboard}
        />
        <TwTaskGroupTitleText
          onDoubleClick={() => boardStore.startEditReport(column)}
        >
          {state.visibleColumnTitle}{' '}
          <Tooltip content={Lang.context.board.counterInColumnsHint2}>
            <Badge type="rounded" size={16} className="inline-flex">
              {state.taskReportCount}
            </Badge>
          </Tooltip>
        </TwTaskGroupTitleText>
        <Tooltip content={Lang.msg.downloadDashboardXlsx}>
          <IconButtonNew
            icon="IconFileDownload"
            className="ml-auto w-24 h-24 p-4 -mx-4"
            onClick={downloadReport}
          />
        </Tooltip>
        <Tooltip content={Lang.msg.dashboardSettings}>
          <IconButtonNew
            icon="IconSettings"
            className="w-24 h-24 p-4 -mx-4"
            onClick={startEdit}
          />
        </Tooltip>
      </TwTitleRow>
      <TwTitleRow className="!items-center empty:hidden">
        <AggregatedUsers
          users={state.taskReportUsers}
          userInfo={state.taskReportUserInfo}
          title={Lang.msg.report.assignedUsers}
          outlineColor="background-primary"
        />
        <AggregatedDeadline items={state.taskReportDeadlines} />
      </TwTitleRow>
      {Boolean(state.numericStickersSum.size) && (
        <TwTitleRow>
          <AggregatedStickerValues />
        </TwTitleRow>
      )}
    </TwTaskGroupTitle>
  )
})
